import { createSlice } from '@reduxjs/toolkit'

export const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState: {
    value: 0,
  },
  reducers: {
    fetchData: (state, action) => {
      state.landingPage = { ...action.payload }
    },
  },
})

export const { fetchData } = landingPageSlice.actions

export default landingPageSlice.reducer
